module.exports = __webpack_public_path__ + "static/media/Image01.f6991384.png";